import utils from "../utils/actionHelpers";

export default {
  videoCount(state) {
    return state.videos.length;
  },
  currents(state) {
    return state.initialData.currents;
  },

  teachers(state) {
    let output = ``;
    if (Array.isArray(state.initialData.teachers)) {
      state.initialData.teachers.forEach((t, i) => {
        if (i === 0) {
          output = t.id;
        } else {
          output = `${output},${t.id}`;
        }
      });
    }
    return output;
  },

  currentOptions(state) {
    const c = [];
    const arr = state.initialData.currents;
    if (arr.length > 0) {
      arr.forEach(current => {
        const curr = {
          ...current
        };
        if (typeof current.resource !== `undefined`) {
          curr.id = current.resource.id;
          c.push(curr);
        }
      });
    }
    return c;
  },

  durationOptions(state) {
    const d = [];
    const arr = state.initialData.durations;
    if (Array.isArray(arr)) {
      arr.forEach(duration => {
        if (typeof duration === `object`) {
          const dur = {
            ...duration
          };
          dur.id = duration.value;
          d.push(dur);
        }
      });
    }
    return d;
  },

  tagToResource: state =>
    // dinamic getter for currents :0
    tag => {
      if (Array.isArray(state.initialData.currents)) {
        const arr = state.initialData.currents.filter(c => {
          if (c.id === tag) {
            return true;
          }
          return false;
        });
        if (typeof arr[0].resource !== `undefined`) {
          return parseInt(arr[0].resource.id, 10);
        }
      }
      return ``;
    },

  equipmentOptions(state) {
    const obj = {
      id: `0`,
      tag: `מזרון`,
      label: `בלי אביזרים`,
      alias: `icon7`,
      group: `2`,
      rank: `7`
    };

    const options = [obj, ...state.initialData.equipment];

    return options;
  },

  levels(state) {
    const levelsArray = [];
    if (Array.isArray(state.initialData.levels)) {
      state.initialData.levels.forEach((lvl, i) => {
        levelsArray.push({
          ...lvl,
          id: i + 1
        });
      });
    }
    return levelsArray;
  },

  durations(state) {
    return state.initialData.durations;
  },
  focus(state) {
    return state.initialData.focus;
  },
  firstName(state) {
    const nameArr = state.user.name.split(` `);
    return nameArr[0];
  },
  lastName(state) {
    const nameArr = state.user.name.split(` `);
    return nameArr[1];
  },
  likedTeachersArray(state) {
    if (state.user.myTeachers && state.user.myTeachers.length > 0) {
      const myTeachers = state.user.myTeachers.split(`,`);
      const output = [];
      if (Array.isArray(state.initialData.teachers)) {
        myTeachers.forEach(t => {
          const teacher = state.initialData.teachers.filter(item => {
            if (parseInt(item.id, 10) === parseInt(t, 10)) {
              return true;
            }
            return false;
          });
          if (typeof teacher[0] !== `undefined`) {
            output.push(teacher[0]);
          }
        });
      }

      return output;
    }
    return [];
  },
  optionQueryObj(state) {
    const arr = Object.values(state.sort.selected);
    const keys = Object.keys(state.sort.selected);
    const obj = {};
    arr.forEach((option, index) => {
      if (option.value !== `all`) {
        if (keys[index] === `cid`) {
          obj[keys[index]] = option.tag;
        } else {
          obj[keys[index]] = option.value;
        }
      }
    });
    if (state.sort.term.length > 0) {
      obj.term = state.sort.term;
    }
    return obj;
  },

  xpSelected(state) {
    const output = state.user.xpConfig.filter(option => option.selected);
    return (
      output[0] || {
        id: 0
      }
    );
  },
  currentSelected(state) {
    const output = [];
    const selected = state.user.styleConfig.filter(option => option.selected);
    selected.forEach(current => {
      state.currents.forEach(c => {
        if (c.resource) {
          const includes = current.includes.map(i => parseInt(i, 10));
          if (includes.indexOf(parseInt(c.resource.id, 10)) > -1) {
            // if (c.label === current.label) {
            output.push(c.resource.id);
          }
        }
      });
    });
    return output;
  },

  currentIds(state) {
    const arr = [];
    state.initialData.currents.forEach(c => {
      if (c.resource) {
        arr.push(c.resource.id);
      }
    });
    return arr;
  },

  newVideos(state) {
    const arr = state.videos;
    // eslint-disable-next-line
    return arr
      .sort(
        (a, b) => Date.parse(b.publishedon) - Date.parse(a.publishedon)
        // eslint-disable-next-line
      )
      .slice(0, 30);
  },
  videoHistory(state) {
    const hist = state.user.history;
    return state.videos.filter(v => hist.includes(`${v.id}`));
  },
  topTeachers(state, getters) {
    const teachers = [];
    getters.videoHistory.forEach(video => {
      let exists = false;
      teachers.forEach(teacher => {
        if (teacher.teacher === video.videoTeacher) {
          exists = true;
          teacher.qty += 1;
        }
      });

      if (!exists) {
        teachers.push({ teacher: video.videoTeacher, qty: 1 });
      }
    });

    return teachers
      .sort((a, b) => {
        return a.qty - b.qty;
      })
      .reverse()
      .slice(0, 3)
      .map(item => item.teacher);
  },
  topStyles(state, getters) {
    const styles = [];
    getters.videoHistory.forEach(video => {
      let exists = false;
      styles.forEach(style => {
        if (style.style === video.current) {
          exists = true;
          style.qty += 1;
        }
      });
      if (!exists) {
        styles.push({ style: video.current, qty: 1 });
      }
    });
    return styles
      .sort((a, b) => {
        return a.qty - b.qty;
      })
      .reverse()
      .slice(0, 5)
      .map(item => item.style);
  },
  averageDuration(state, getters) {
    const durations = getters.videoHistory.map(item => item.videoDuration);
    if (durations.length > 0) {
      return (
        durations.reduce((a, b) => parseInt(a, 10) + parseInt(b, 10)) /
        durations.length
      ).toFixed(2);
    }
    return 0;
  },
  averageLevel(state, getters) {
    const levels = getters.videoHistory.map(item =>
      parseInt(item.videoLvl, 10)
    );
    if (levels.length > 0) {
      return (levels.reduce((a, b) => a + b) / levels.length).toFixed(2);
    }
    return 0;
  },

  videoFocus: state => video => {
    const output = [];
    const focusList = state.initialData.focus;
    video.equipment.forEach(item => {
      const filtered = focusList.filter(f => f.id === item.tag);
      if (filtered.length > 0) {
        output.push(filtered[0]);
      }
    });
    return output;
  },

  inHistory: state => videoId => {
    return state.user.history.includes(videoId);
  },

  averageFocus(state, getters) {
    let output = [];
    getters.videoHistory.forEach(item => {
      output = [...output, ...getters.videoFocus(item)];
    });
    if (output.length > 0) {
      return (
        output.reduce((a, b) => {
          if (a.rank) {
            return parseInt(a.rank, 10) + parseInt(b.rank, 10);
          }
          return a + parseInt(b.rank, 10);
        }) / output.length
      ).toFixed(2);
    }
    return 0;
  },

  recommendedVideos(state, getters) {
    let output = [];

    if (getters.videoHistory.length < 10) {
      //get from prefs
      output = utils.getRecommended(state, getters, 3);
    } else {
      output = utils.getRecommended(state, getters, 7);

      if (output.length < 4) {
        output = utils.getRecommended(state, getters, 6);
      }
    }

    return utils.shuffleArray(output);
  },
  getTeacher: state => id => {
    const filtered = state.initialData.teachers.filter(item => item.id === id);
    return filtered[0];
  },
  getStyle: state => id => {
    const filtered = state.currents.filter(item => item.resource.id === id);
    return filtered[0];
  },
  getMeta: state => id => {
    const filtered = state.initialData.styles.filter(
      item => item.MIGX_id === `${id}`
    );

    return filtered[0];
  },

  prefs(state, getters) {
    let output = {};

    output.focus = state.user.interestConfig.filter(item => item.selected);
    output.metaStyle = state.user.currentConfig.filter(item => item.selected);
    output.metaStyle.map(meta => {
      meta.includes = getters.getMeta(meta.metaId).includes;
    });
    output.level = state.user.xpConfig.filter(item => item.selected)[0];
    output.tempo = state.user.tempoConfig.filter(item => item.selected)[0];
    output.duration = state.user.durationConfig.filter(
      item => item.selected
    )[0];

    return output;
  }
};
